import type { ReactNode } from 'react';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router';
import { type Plan } from '@/data/idp/plans/interfaces';

type PlanCard = {
  cardActionLabel?: string;
  children?: ReactNode;
  hideTitle?: boolean;
  plan: Plan;
};

export const PlanCard = ({
  cardActionLabel = 'Ver Plano',
  children,
  hideTitle = false,
  plan,
}: PlanCard) => {
  const navigate = useNavigate();

  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {!hideTitle && (
        <CardHeader
          title={
            <Typography variant="h3">
              {plan?.title || 'Plano sem título'}
            </Typography>
          }
        />
      )}
      <Stack>
        <CardContent
          sx={{ paddingBottom: '0', ...(!hideTitle && { paddingTop: '0' }) }}
        >
          {children}
        </CardContent>
        <CardActions sx={{ marginTop: 'auto' }}>
          <Button
            endIcon={<ArrowForwardRoundedIcon />}
            href={`/pdi/planos/${plan?.id}`}
            onClick={(e) => {
              e.preventDefault();
              navigate(`/pdi/planos/${plan?.id}`);
            }}
          >
            {cardActionLabel}
          </Button>
        </CardActions>
      </Stack>
    </Card>
  );
};
